module.exports = __webpack_public_path__ + "static/media/noData.9de22bb2.svg";